class SmiffysCollectionBanner extends HTMLElement{
  constructor(){
    super();
  }
  
  connectedCallback(){
    let title = this.querySelector('.description-true .collection-hero__title');
    if(title){
      title.addEventListener('click', (event)=>{
        let description = title.closest('.description-true');
        if(description.classList.contains('open')){
          description.classList.remove('open');
        }else{
          description.classList.add('open');
        }
        
      });
    }
    
    let ulElement = this.querySelector("#collection-accordion > ul");
    if(ulElement && ulElement.offsetHeight + 50 < ulElement.scrollHeight){
      this.querySelector("#collection-accordion .collection-accordion-footer a.btn-collection-more").style.visibility = "visible";
    }
    
    let moreBtn = this.querySelector("#collection-accordion .collection-accordion-footer a.btn-collection-more");
    if(moreBtn){
      moreBtn.addEventListener('click', (event)=>{
          let link = this.querySelector("#collection-accordion");
        if(link.classList.contains('expanded')){
          link.classList.remove('expanded');
        }else{
          link.classList.add('expanded');
        }
      });
    }
    
    let descriptionDiv = this.querySelector(".collection-hero__description");
    if(descriptionDiv && descriptionDiv.offsetHeight < descriptionDiv.scrollHeight){
      this.querySelector(".collection-description-footer a.btn-collection-more").style.visibility = "visible";
    }
    
    let moreBtn2 = this.querySelector(".collection-description-footer a.btn-collection-more");
    if(moreBtn2){
      moreBtn2.addEventListener('click', (event)=>{
          let link = this.querySelector(".collection-hero__description");
        if(link.classList.contains('expanded')){
          link.classList.remove('expanded');
        }else{
          link.classList.add('expanded');
        }
      });
      }
      this.makeRoundIcons();
    }
    makeRoundIcons() {
        this.querySelectorAll("#collection-accordion > ul > li > div > a > img").forEach(x => {
            x.outerHTML = "<div class='roundborder'>" + x.outerHTML + "</div>";
        });
    }
}
window.customElements.define('smiffys-collection-banner', SmiffysCollectionBanner);